import { User, Mail, Phone, FileText } from "lucide-react";
import { Input } from "@/shared/components/ui/input";
import { SectionCard, FormRow } from "./WithdrawalUI";

export default function RecipientInfoSection({
  form,
  updateField,
  fieldRefs,
  errors,
}) {
  const handleChange = (field, value) => {
    const formattedValue =
      field === "phone" || field === "document_id"
        ? value.replace(/[^0-9]/g, "")
        : value;

    updateField(field, formattedValue);
  };

  return (
    <SectionCard icon={User} title="Recipient Information">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormRow id="firstname" label="First Name *" error={errors.firstname}>
          <Input
            id="firstname"
            ref={(el) => (fieldRefs.current.firstname = el)}
            value={form.firstname}
            onChange={(e) => handleChange("firstname", e.target.value)}
            placeholder="Ahmed"
            className="h-11 rounded-xl"
          />
        </FormRow>

        <FormRow id="lastname" label="Last Name *" error={errors.lastname}>
          <Input
            id="lastname"
            ref={(el) => (fieldRefs.current.lastname = el)}
            value={form.lastname}
            onChange={(e) => handleChange("lastname", e.target.value)}
            placeholder="Khan"
            className="h-11 rounded-xl"
          />
        </FormRow>

        <FormRow id="email" label="Email *" error={errors.email} icon={Mail}>
          <Input
            id="email"
            ref={(el) => (fieldRefs.current.email = el)}
            type="email"
            autoComplete="email"
            value={form.email}
            onChange={(e) => handleChange("email", e.target.value)}
            placeholder="recipient@example.com"
            className="pl-10 h-11 rounded-xl"
          />
        </FormRow>

        <FormRow
          id="phone"
          label="Wallet Number *"
          error={errors.phone}
          icon={Phone}
          hint="Format: 03XXXXXXXXX"
        >
          <Input
            id="phone"
            ref={(el) => (fieldRefs.current.phone = el)}
            value={form.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
            placeholder="03XXXXXXXXX"
            maxLength={11}
            className="pl-10 h-11 rounded-xl"
          />
        </FormRow>

        <div className="sm:col-span-2">
          <FormRow
            id="document_id"
            label="CNIC Number *"
            error={errors.document_id}
            icon={FileText}
            hint="13-digit CNIC (no dashes)"
          >
            <Input
              id="document_id"
              ref={(el) => (fieldRefs.current.document_id = el)}
              value={form.document_id}
              onChange={(e) => handleChange("document_id", e.target.value)}
              placeholder="1234567890123"
              maxLength={13}
              className="pl-10 h-11 rounded-xl"
            />
          </FormRow>
        </div>
      </div>
    </SectionCard>
  );
}
